import React, { useMemo } from "react";
import Dropdown from "components/Elements/Dropdown";
import FieldLabel from "./FieldLabel";

const ReportPickerField = ({ reports = [], value, onChange, disabled = false }) => {
	const options = useMemo(
		() => reports.map((r) => ({ label: r.name, value: r.reportType })),
		[reports]
	);
	const selected = options.find((o) => o.value === value) || {};

	return (
		<div>
			<FieldLabel required>Which report?</FieldLabel>
			<Dropdown
				options={options}
				selectedValue={selected}
				onChange={(opt) => onChange(opt.value)}
				placeholder="Select a report"
				width="100%"
				disabled={disabled}
			/>
		</div>
	);
};

export default ReportPickerField;
